export function formatLithuanianPhone(value: string): string {
    const digits = value.replace(/\D/g, '');
    const limited = digits.slice(0, 8);

    if (limited.length <= 3) {
        return limited;
    } else if (limited.length <= 5) {
        return `${limited.slice(0, 3)} ${limited.slice(3)}`;
    } else {
        return `${limited.slice(0, 3)} ${limited.slice(3, 5)} ${limited.slice(5)}`;
    }
}
